import React, { useEffect } from 'react';
import '../style/galleryimage.css';
import 'aos/dist/aos.css';
import AOS from 'aos';
import { Link } from 'react-router-dom';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Typography } from '@mui/material';
import { FaArrowRight } from 'react-icons/fa';
import { LuSparkle } from 'react-icons/lu';
import Images  from '../images/gallery-photo1.jpg';
import Images2 from '../images/gallery-photo2.jpg';
import Images3 from '../images/gallery-photo3.jpg';
import Images4 from '../images/gallery-photo4.jpg';

function GalleryImages() {
  useEffect(() => {
    AOS.init({
      offset: 80,
      duration: 700,
      easing: 'ease-out-cubic',
      once: true,
    });
  }, []);

  const imageGallery = [
    { image: Images,  label: 'Büroreinigung' },
    { image: Images2, label: 'Glasreinigung' },
    { image: Images3, label: 'Fassade' },
    { image: Images4, label: 'Treppenhaus' },
  ];

  return (
    <div className="content-gallery-image" id="gallery-scroll">

      {/* ── HEADER ── */}
      <div className="gallery-header">
        <div className="gallery-header-line" />
        <span className="gallery-header-label">
          <LuSparkle className="gallery-sparkle-icon" />
          Unsere Arbeit
          <LuSparkle className="gallery-sparkle-icon" />
        </span>
        <div className="gallery-header-line" style={{ transform: 'scaleX(-1)' }} />
      </div>

      {/* ── TITLE ROW ── */}
      <div className="exploreandneust">
        <Typography
          variant="h4"
          className="newproject"
          data-aos="fade-right"
          data-aos-duration="700"
          data-aos-once="true"
          sx={{
            color: 'var(--textColor)',
            marginBottom: '20px',
            width: '40%',
            fontFamily: 'var(--fontFamily)',
            fontWeight: 700,
          }}
        >
          Neueste Projekte
        </Typography>

        <span
          data-aos="fade-left"
          data-aos-duration="700"
          data-aos-once="true"
        >
          <Link
            to="/galerieseite"
            style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}
          >
            Entdecke mehr <FaArrowRight style={{ fontSize: '14px' }} />
          </Link>
        </span>
      </div>

      {/* ── IMAGES ── */}
      <div className="gallery">
        {imageGallery.map((item, index) => (
          <div
            className="imagesSrc"
            key={index}
            data-aos="zoom-in"
            data-aos-delay={index * 100}
            data-aos-duration="700"
            data-aos-once="true"
          >
            <LazyLoadImage
              src={item.image}
              alt={item.label}
              loading="lazy"
              style={{ width: '100%', height: 'auto', display: 'block' }}
            />
          </div>
        ))}
      </div>

    </div>
  );
}

export default GalleryImages;